import { Button as AntdButton } from 'antd';
import { CSSProperties } from 'react';
import styled from '@emotion/styled';

type Props = {
  color?: CSSProperties['color'];
};

export const Button = styled(AntdButton)<Props>((props) => ({
  color: props.color,
  '&&': {
    fontSize: 16,
    padding: 0,
  },
}));
